/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "AddressValidationError": {
                "fields": {
                  "errorCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "serviceName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE AddressValidationError @ squareup/solidshop/model/address_validation_error.proto at 8:1
 */
export const AddressValidationError = $root.lookupType('squareup.solidshop.model.AddressValidationError');
fixType(AddressValidationError);
Builder.createAndAttachToType(AddressValidationError);
